import { call, put, getContext, takeLatest } from "redux-saga/effects";

import {
  deleteLocationBlockerFailure,
  deleteLocationBlockerSuccess,
  getLocationBlockerLocationsFailure,
  getLocationBlockerLocationsSuccess,
  setLocationBlockerFailure,
  setLocationBlockerSuccess,
  getLocationBlockerLocations as getLocationBlockerLocationsRequest,
} from "./actions";
import { CONTEXT } from "@const/redux";
import {
  deleteLocationBlockerActionTypes,
  getLocationBlockerLocationsActionTypes,
  setLocationBlockerActionTypes,
} from "./actionTypes";

const getLocationBlockerLocationsAsync = ({ LocationBlockerService }) => {
  if (!LocationBlockerService) {
    console.log("Required services does not exist");
    return null;
  }

  return LocationBlockerService.getLocationBlockerLocations();
};

function* getLocationBlockerLocations() {
  const { LocationBlockerService } = yield getContext(CONTEXT.SERVICES);

  try {
    const { data } = yield call(getLocationBlockerLocationsAsync, {
      LocationBlockerService,
    });

    yield put(getLocationBlockerLocationsSuccess(data));
  } catch ({ error }) {
    yield put(getLocationBlockerLocationsFailure(error));
  }
}

const setLocationBlockerAsync = ({ LocationBlockerService, ...payload }) => {
  if (!LocationBlockerService) {
    console.log("Required services does not exist");
    return null;
  }

  return LocationBlockerService.setLocationBlocker(payload);
};

function* setLocationBlocker({ payload }) {
  const { LocationBlockerService } = yield getContext(CONTEXT.SERVICES);

  try {
    const { data } = yield call(setLocationBlockerAsync, {
      LocationBlockerService,
      ...payload,
    });

    yield put(setLocationBlockerSuccess(data));
  } catch ({ error }) {
    const { ToasterService } = yield getContext(CONTEXT.SERVICES);

    ToasterService.errorTranslated(
      error?.message || error.error?.message || "Something went wrong",
    );
    yield put(setLocationBlockerFailure(error));
  }
}
const deleteLocationBlockerAsync = ({ LocationBlockerService, id }) => {
  if (!LocationBlockerService) {
    console.log("Required services does not exist");
    return null;
  }

  return LocationBlockerService.deleteLocationBlocker({ id });
};

function* deleteLocationBlocker({ payload }) {
  const { LocationBlockerService } = yield getContext(CONTEXT.SERVICES);

  try {
    yield call(deleteLocationBlockerAsync, {
      LocationBlockerService,
      id: payload.id,
    });

    yield put(deleteLocationBlockerSuccess());
    yield put(getLocationBlockerLocationsRequest());
  } catch ({ error }) {
    yield put(deleteLocationBlockerFailure(error));
  }
}
export function* watchGetLocationBlockerLocations() {
  yield takeLatest(
    getLocationBlockerLocationsActionTypes.request,
    getLocationBlockerLocations,
  );
}
export function* watchSetLocationBlocker() {
  yield takeLatest(setLocationBlockerActionTypes.request, setLocationBlocker);
}

export function* watchDeleteLocationBlocker() {
  yield takeLatest(
    deleteLocationBlockerActionTypes.request,
    deleteLocationBlocker,
  );
}
